module.exports = __webpack_public_path__ + "static/img/gzh_img.8ad656f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/new/index/gzh_img.jpg
// module id = mfCh
// module chunks = 24